import { render, staticRenderFns } from "./box3.vue?vue&type=template&id=c290fd3e&scoped=true&"
import script from "./box3.vue?vue&type=script&lang=js&"
export * from "./box3.vue?vue&type=script&lang=js&"
import style0 from "./box3.vue?vue&type=style&index=0&id=c290fd3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c290fd3e",
  null
  
)

export default component.exports